webpackJsonp([65579394461380],{

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Section = __webpack_require__(3);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Impact = function Impact() {
	  return _react2.default.createElement(
	    _Section2.default,
	    { title: 'Impact', shade: 4 },
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ongoing development of the design system at New Engen has resulted in:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'New Storybook library open to engineers, designers, and product managers'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'A single source of truth with documented designs and guidelines for their uses'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'A Figma library used to efficiently craft cohesive high-fidelity designs'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Cross-functional team of designers and engineers that are excited about creating high quality experiences'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Increasingly collaborative approach between design & engineering as a result of the project'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'UX team spending more time on the overall user experience and user interactions instead of focusing efforts on UI design.'
	      )
	    ),
	    _react2.default.createElement(
	      'blockquote',
	      null,
	      '"Matt was instrumental in updating our UX Design System into a tool that allowed for better collaboration and interaction for the UX Team. He was proactive in making sure that our components, styles and patterns were always documented and up-to-date with industry standards. Matt also worked closely with the engineering team to ensure the system was properly built out, which was crucial for the successful implementation into our production environment." ',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      '- Jason Bourguignon, Director of Design at New Engen'
	    )
	  );
	};
	
	exports.default = Impact;
	module.exports = exports['default'];

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Section = __webpack_require__(3);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Image = __webpack_require__(5);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _designsystemteam = __webpack_require__(407);
	
	var _designsystemteam2 = _interopRequireDefault(_designsystemteam);
	
	var _slackcomms = __webpack_require__(441);
	
	var _slackcomms2 = _interopRequireDefault(_slackcomms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Process = function Process() {
	  return _react2.default.createElement(
	    _Section2.default,
	    { shade: 2, title: 'Process Improvements' },
	    _react2.default.createElement(
	      _Section.SubSection,
	      { title: 'Cross-Functional Design System Team' },
	      _react2.default.createElement(
	        'p',
	        null,
	        'With the support of the Director of UX, I was able to allocate some of my own time on an ongoing basis to this effort. Likewise, I met with the engineering team and identified a point person and a few others that were interested and could contribute.'
	      ),
	      _react2.default.createElement(_Image2.default, { alt: 'Design System Team', src: _designsystemteam2.default })
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      _Section.SubSection,
	      { title: 'Communication Touchpoints' },
	      _react2.default.createElement(
	        'p',
	        null,
	        'With a team of contributors and stakeholders identified, we needed a forum to discuss implementation and iteration. I created two channels for these discussions:'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'A weekly sync to run through open questions and identify next steps'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'A Slack channel for async and ad hoc decision making'
	        )
	      ),
	      _react2.default.createElement(_Image2.default, { alt: 'Design System Slack communication', src: _slackcomms2.default })
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      _Section.SubSection,
	      { title: 'System Iteration' },
	      _react2.default.createElement(
	        'p',
	        null,
	        'In order to fully embrace our "only build what we need" principle, I created a process that the team could follow when evaluating new components or component iteration opportunities.'
	      ),
	      _react2.default.createElement('iframe', {
	        title: 'Design System Iteration Process on Whimsical',
	        style: { border: 'none' },
	        width: '100%',
	        height: '400',
	        src: 'https://whimsical.com/embed/NJ8qF3gyHMHtSXFsxcwsKz'
	      })
	    )
	  );
	};
	
	exports.default = Process;
	module.exports = exports['default'];

/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Section = __webpack_require__(3);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Image = __webpack_require__(5);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _dslogos = __webpack_require__(408);
	
	var _dslogos2 = _interopRequireDefault(_dslogos);
	
	var _toollogos = __webpack_require__(452);
	
	var _toollogos2 = _interopRequireDefault(_toollogos);
	
	var _audit = __webpack_require__(406);
	
	var _audit2 = _interopRequireDefault(_audit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Research = function Research() {
	  return _react2.default.createElement(
	    _Section2.default,
	    { shade: 1, title: 'Research' },
	    _react2.default.createElement(
	      _Section.SubSection,
	      { title: 'Existing System Audit' },
	      _react2.default.createElement(
	        'p',
	        null,
	        'The design system work up to the point I took over was primarily based on',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://www.carbondesignsystem.com/', target: '_blank' },
	          'IBM Carbon design system'
	        ),
	        '. Many of the components were just placeholders and never introduced into our platform; other components were used but never standardized. During the first stage of research, I worked with the design and engineering teams to fully audit the existing system and answer the following questions:'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'em',
	            null,
	            'Component inventory'
	          ),
	          ' - which components were being used, which were not?'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'em',
	            null,
	            'Consistency of application'
	          ),
	          ' - to what degree did components and styles in the product adhere to the system?'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'em',
	            null,
	            'Gaps'
	          ),
	          ' - what are the missing or incomplete components?'
	        )
	      ),
	      _react2.default.createElement(_Image2.default, { alt: 'Design audit of a page', src: _audit2.default })
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      _Section.SubSection,
	      { title: 'Comparative Research' },
	      _react2.default.createElement(
	        'p',
	        null,
	        'As a small team with limited resources, it was important that we build on the work of other well constructed design system efforts. In conducting research, I prioritized libraries that shared some commonalities with New Engen\'s product and user base.'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Enterprise, B2B, SAAS products'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Marketing or marketing adjacent'
	        )
	      ),
	      _react2.default.createElement(_Image2.default, { alt: 'Design System Logos', src: _dslogos2.default }),
	      _react2.default.createElement(
	        'p',
	        null,
	        'This research helped us to identify concepts that we would need to include in the system, design patterns that were important to enterprise marketing users, and organizational heirarchies that we could use to structure our work.'
	      )
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      _Section.SubSection,
	      { title: 'Tooling Analysis' },
	      _react2.default.createElement(
	        'p',
	        null,
	        'During the initial phases of this project, I also decided to analyze how we were using design tools and whether our current set of tools could meet our needs effectively. Specifically, the things I was focused on were:'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Cost'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Ease of collaboration'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Industry trends'
	        )
	      ),
	      _react2.default.createElement(_Image2.default, { alt: 'Tooling Logos', src: _toollogos2.default }),
	      _react2.default.createElement(
	        'p',
	        null,
	        'I researched Abstract for Sketch, Invision\'s Design System Manager and Figma for potential solutions. Ultimately, based on these criteria, I made a recommendation and we decided to migrate to Figma.'
	      )
	    ),
	    _react2.default.createElement(
	      _Section.SubSection,
	      { title: 'Design Priciple Synthesis' },
	      _react2.default.createElement(
	        'p',
	        null,
	        'The ultimate goal of the research phase of this project was to synthesize a small number of design priciples that we could use to guide our work through implementation. Through discussing research findings with other designers, engineers, and product stakeholders, we were able to come up with three rules to live by.'
	      ),
	      _react2.default.createElement(
	        'h4',
	        null,
	        'Build only what we need'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'As a small product team, we wanted our main focus to be on building features. The design system would be augmented and iterated on only as product needs required. Additionally, we learned that speculative designing for theoritical future use cases often resulted in unused work or work that made bad assumptions. By building only what we need, when we need it, we could avoid this wasted effort.'
	      ),
	      _react2.default.createElement(
	        'h4',
	        null,
	        'Make color matter'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Our users are trying to do their job and have complex workflows. Our visual design should work to simplify those workflows and not distract. Therefore, color and other "loud" visual design is only used when it has an explicit purpose.'
	      ),
	      _react2.default.createElement(
	        'h4',
	        null,
	        'Accessibile design'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'In much of our original design system, accessibility was an afterthought. This manifested in ways that impacted all users (insufficient color contrast, small font sizes, etc). It was important to our entire product team that our product not exclude potential users with permanent, temporary, or situational impairments.'
	      )
	    )
	  );
	};
	
	exports.default = Research;
	module.exports = exports['default'];

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Section = __webpack_require__(3);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Image = __webpack_require__(5);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Color = __webpack_require__(388);
	
	var _Color2 = _interopRequireDefault(_Color);
	
	var _Spacing = __webpack_require__(403);
	
	var _Spacing2 = _interopRequireDefault(_Spacing);
	
	var _Buttons = __webpack_require__(387);
	
	var _Buttons2 = _interopRequireDefault(_Buttons);
	
	var _Modals = __webpack_require__(400);
	
	var _Modals2 = _interopRequireDefault(_Modals);
	
	var _Tables = __webpack_require__(405);
	
	var _Tables2 = _interopRequireDefault(_Tables);
	
	var _Navigation = __webpack_require__(401);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var System = function System() {
	  return _react2.default.createElement(
	    _Section2.default,
	    { shade: 3, title: 'The System' },
	    _react2.default.createElement(
	      _Section.SubSection,
	      { title: 'Aritfacts' },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Based on some of the work in Brad Frost\'s',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          {
	            href: 'https://bradfrost.com/blog/post/atomic-web-design/',
	            target: '_blank'
	          },
	          'Atomic Design'
	        ),
	        ', I decided we would structure our design system into Styles, Components and Patterns which closely mirrors atoms, molecules and organisms in his book.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'This organizational structure would then be consistently applied to the following deliverables:'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Shared Figma library used by the UX team to create high fidelity designs'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Centralized documentation that would act as a single source of truth for design and engineering'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Front end library in Storybook'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'What follows is a sampling of each of these concepts in the new New Engen Design System.'
	      )
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      _Section.SubSection,
	      { title: 'Styles' },
	      _react2.default.createElement(_Image2.default, { alt: 'Spacing in the Design System', src: _Spacing2.default }),
	      _react2.default.createElement(_Image2.default, { alt: 'Colors in the Design System', src: _Color2.default })
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      _Section.SubSection,
	      { title: 'Components' },
	      _react2.default.createElement(_Image2.default, { alt: 'Buttons in the Design System', src: _Buttons2.default }),
	      _react2.default.createElement(_Image2.default, { alt: 'Modals in the Design System', src: _Modals2.default })
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      _Section.SubSection,
	      { title: 'Patterns' },
	      _react2.default.createElement(_Image2.default, { alt: 'Tables in the Design System', src: _Tables2.default }),
	      _react2.default.createElement(_Image2.default, { alt: 'Navigation in the Design System', src: _Navigation2.default })
	    )
	  );
	};
	
	exports.default = System;
	module.exports = exports['default'];

/***/ }),

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Buttons.ebfd8410.jpg";

/***/ }),

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Color.3a628b80.jpg";

/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Modals.23c17888.jpg";

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/NEDesignSystemHero.a85e83ac.jpg";

/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Navigation.674001f6.jpg";

/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Spacing.83cde93a.jpg";

/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Tables.7c34a90d.jpg";

/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/audit.17e7f0e2.jpg";

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/designsystemteam.c7f4fec1.png";

/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/dslogos.631e9267.png";

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hazel.2f1edff7.jpg";

/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/slackcomms.a46e03f6.png";

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/toollogos.2a699aee.png";

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Hero = __webpack_require__(11);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _NEDesignSystemHero = __webpack_require__(62);
	
	var _NEDesignSystemHero2 = _interopRequireDefault(_NEDesignSystemHero);
	
	var _hazel = __webpack_require__(64);
	
	var _hazel2 = _interopRequireDefault(_hazel);
	
	var _Overview = __webpack_require__(26);
	
	var _Overview2 = _interopRequireDefault(_Overview);
	
	var _Section = __webpack_require__(3);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _WorkItem = __webpack_require__(13);
	
	var _WorkItem2 = _interopRequireDefault(_WorkItem);
	
	var _Research = __webpack_require__(178);
	
	var _Research2 = _interopRequireDefault(_Research);
	
	var _Process = __webpack_require__(177);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _System = __webpack_require__(179);
	
	var _System2 = _interopRequireDefault(_System);
	
	var _Impact = __webpack_require__(176);
	
	var _Impact2 = _interopRequireDefault(_Impact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NewEngenDesignSystem = function NewEngenDesignSystem() {
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: 'New Engen Design System | matt harris' }),
	    _react2.default.createElement(
	      _Hero2.default,
	      {
	        title: 'New Engen Design System',
	        image: _NEDesignSystemHero2.default,
	        imageAlt: 'New Engen Design System'
	      },
	      _react2.default.createElement(
	        'p',
	        null,
	        'The Design System for SAAS Marketing Company, New Engen'
	      )
	    ),
	    _react2.default.createElement(
	      _Overview2.default,
	      {
	        company: _react2.default.createElement(
	          'a',
	          { href: 'https://newengen.com', target: '_blank' },
	          'New Engen'
	        ),
	        tools: 'Sketch to Figma',
	        deliverables: 'Figma Design System, Storybook',
	        role: 'Design Lead',
	        impact: 'Over this ongoing project, I led the design, development, implementation, and support of a design system in collaboration with two other product designers and four engineers.',
	        problem: 'The existing New Engen design system wasn\'t consistently applied or used by either designers or developers, which resulted in a disjointed design across the product and lost time on our product and engineering teams.',
	        goal: 'Operationalize a new design system that fits our company\'s mission to create a consistent user experience and save our teams time and money.'
	      },
	      _react2.default.createElement(
	        _Section2.default,
	        null,
	        _react2.default.createElement(
	          _Section.SubSection,
	          { title: 'Background' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'At the beginning of 2019, New Engen had a design system that was failing our product and engineering teams. The design system as it stood had a number of issues:'
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              'Design system was siloed in a designer-owned Sketch file'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'No centralized implementation existed in the web front end'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Patterns and components weren\'t being reused on either the design or development side'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'No process to add or audit the design system existed'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'No "source of truth" led to incosistent application of standards'
	            )
	          )
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          _Section.SubSection,
	          { title: 'Solution Overview' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'The scope of the challenges that existed in the existing design system made it clear that an iterative approach wouldn\'t be sufficient\u2013we needed to rethink the system from the ground up.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Recognizing this, I proposed a three part solution and aligned the team including the director of UX and VP of engineering behind it:'
	          ),
	          _react2.default.createElement(
	            'ol',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              'Conduct internal and external ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'research'
	              ),
	              ' to arrive at a set of guiding principles'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Implement a set of ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'process improvements'
	              ),
	              ' to ensure the team and the system stays in sync'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Work collaboratively to implement a initial version of',
	              ' ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'the system'
	              ),
	              ' that we could continue to build on'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_Research2.default, null),
	    _react2.default.createElement(_Process2.default, null),
	    _react2.default.createElement(_System2.default, null),
	    _react2.default.createElement(_Impact2.default, null),
	    _react2.default.createElement(
	      _Section2.default,
	      { shade: 5 },
	      _react2.default.createElement(
	        'h4',
	        null,
	        'Keep Reading'
	      ),
	      _react2.default.createElement(_WorkItem2.default, {
	        link: '/hazel/',
	        title: 'Hazel Analytics',
	        subtitle: 'Web app redesign',
	        image: _hazel2.default
	      })
	    )
	  );
	};
	
	exports.default = NewEngenDesignSystem;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-new-engen-design-system-js-7edb89610753aa8be300.js